import { useEffect } from 'react';
import { useIsMounted } from '@toss/react';
import { useRouter } from 'next/router';
import { logger } from '@zep/core-logger';
import { useIsInGoogleClassroom } from '@/shared/googleClassroom/hooks/useIsInGoogleClassroom';
import { sendPageView } from '@/utils/analytics';
export const usePageViewLogging = () => {
  const router = useRouter();
  const isMounted = useIsMounted();
  const isInGoogleClassroom = useIsInGoogleClassroom();
  useEffect(() => {
    if (router.isReady && isMounted) {
      logger.track('page_view', {
        location: router.pathname,
        googleClassroom: isInGoogleClassroom
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router.isReady, isMounted, router.pathname]);
  useEffect(() => {
    const handleRouteChange = (url: string) => {
      sendPageView(url);
    };
    router.events.on('routeChangeStart', handleRouteChange);
    return () => {
      router.events.off('routeChangeStart', handleRouteChange);
    };
  }, [router]);
};